import axios from 'axios';

import BaseModal from '../base-modal/base-modal';
import notification from '../notification/notification';

import './contact-modal.scss';


class ContactModal extends BaseModal {
  apiUrl;

  ui = {
    form: '#contact-form',
    formError: '.js-form-error',
    submit: '.js-send-contact-button',
  };

  events = {
    'submit @ui.form': 'handleFormSubmit',
  };

  onInit() {
    super.onInit();
    this.apiUrl = (this.ui.form as unknown as HTMLFormElement).action;
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.disableSubmitBtn();
    this.hideErrors();
    this.submit();
  }

  submit() {
    const data = new FormData((this.ui.form as unknown as HTMLFormElement));

    return axios.post(this.apiUrl, Object.fromEntries(data.entries()))
      .then(this.onSuccessfulRequest)
      .catch(this.handleFormError)
      .finally(this.enableSubmitBtn.bind(this));
  }

  handleFormError = ({ response }) => {
    const { data: { errors } } = response;

    errors.forEach((error) => {
      const errorMessage = error.detail || (this.ui.form as unknown as HTMLFormElement).dataset.defaultError;

      if (error.source && error.source.parameter) {
        this.showFieldError(error.source.parameter, errorMessage);
      } else {
        this.showFormError(errorMessage);
      }
    });
  };

  showFieldError(fieldName, errorText) {
    const field = (this.ui.form as unknown as HTMLFormElement).elements[fieldName];

    if (!field) {
      return;
    }

    if (field.nextElementSibling) {
      field.nextElementSibling.textContent = errorText;
    }

    field.classList.add('form-group__form-control_invalid');
  }

  showFormError(errorText) {
    (this.ui.formError as unknown as HTMLElement).textContent = errorText;
    (this.ui.formError as unknown as HTMLElement).classList.add('d-block');
  }

  hideErrors() {
    Object.values((this.ui.form as unknown as HTMLFormElement).elements).forEach((field) => {
      field.classList.remove('form-group__form-control_invalid');
    });

    (this.ui.formError as unknown as HTMLElement).classList.remove('d-block');
  }

  disableSubmitBtn() {
    (this.ui.submit as unknown as HTMLButtonElement).disabled = true;
  }

  enableSubmitBtn() {
    (this.ui.submit as unknown as HTMLButtonElement).disabled = false;
  }

  onSuccessfulRequest = ({ data: responseData }) => {
    (this as BaseModal).close();
    (this.ui.form as unknown as HTMLFormElement).reset();
    notification.success(responseData.data.label);
  };
}

export default ContactModal;
